import NudosRadioButton from 'components/NudosRadioButton/NudosRadioButton';
import { TRequotePriceSelection } from 'types/quoteEditor.types';
import { formatQuotePrice } from 'views/Quote/utils/formatQuotePrice';
import './RequotePriceSelector.scss';

interface IRequotePriceSelector {
  recotizedPrice: string;
  previousPrice: string;
  saleCurrency: string;
  selected?: TRequotePriceSelection;
  isDeactivated?: boolean;
  onChange: (selection: TRequotePriceSelection) => void;
}

/**
 * Selector obligatorio del precio final a ofrecer en una recotización.
 * Procurement elige entre el precio recotizado y el de la cotización original.
 */
const RequotePriceSelector = ({
  recotizedPrice,
  previousPrice,
  saleCurrency,
  selected,
  isDeactivated,
  onChange
}: IRequotePriceSelector) => {
  const options: { value: TRequotePriceSelection; label: string; price: string }[] = [
    { value: 'requoted', label: 'Recotizado', price: recotizedPrice },
    { value: 'previous', label: 'Anterior', price: previousPrice }
  ];

  return (
    <div className="requotePriceSelector">
      <span className="selectorLabel">Selecciona el precio final a ofrecer</span>
      <div className="selectorOptions">
        {options.map(option => {
          const isActive = selected === option.value;
          return (
            <div
              key={option.value}
              className={`selectorOption${isActive ? ' active' : ''}${isDeactivated ? ' deactivated' : ''}`}
              onClick={isDeactivated ? undefined : () => onChange(option.value)}
            >
              <NudosRadioButton
                isButtonActive={isActive}
                handleClickButton={isDeactivated ? () => {} : () => onChange(option.value)}
              />
              <span className="optionText">
                {option.label} <span className="optionPrice">{formatQuotePrice(option.price, saleCurrency)}</span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RequotePriceSelector;
